import { render } from "./TheModal.vue?vue&type=template&id=6049d70c&scoped=true&lang=pug"
import script from "./TheModal.vue?vue&type=script&lang=js"
export * from "./TheModal.vue?vue&type=script&lang=js"

import "./TheModal.vue?vue&type=style&index=0&id=6049d70c&lang=scss&scoped=true"

import exportComponent from "/builds/fenix/ais-abr/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6049d70c"]])

export default __exports__